// extracted by mini-css-extract-plugin
export default {"business":"ProductList_business__cMKIi","list":"ProductList_list__UBvup","item":"ProductList_item__eze0q","text":"ProductList_text__PqmjS"};